import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';
import authUsersReducer from './slices/auth/authUserSlice';

import routesReducer from './slices/routes/routesSlice';

import moduleReducer from './slices/module/moduleSlice';
import moduleCategoryReducer from './slices/moduleCategory/moduleCategorySlice';

import profileReportReducer from './slices/profile/profileReportSlice';

import alertsSlice from './slices/alerts/alertsSlice';
import confirmModalReducer from './slices/confirmModal/confirmModalSlice'
import formAlertSliceReducer from './slices/alerts/formAlertSlice';
import modalsReducer from './slices/modals/modalsSlice';
import sessionReducer from './slices/session/sessionSlice';
import menuReducer from './slices/menu/menuSlice';
import categoriesMenuReducer from './slices/categoriesMenu/categoriesMenuSlice';
import entityTypeReducer from './slices/entityType/entityTypeSlice';
import taxpayerCategoryReducer from './slices/taxpayerCategories/taxpayerCategorySlice';
import documentTypeReducer from './slices/documentTypes/documentTypeSlice';
import documentIdentificationTypeReducer from './slices/documentIdentificationType/documentIdentificationTypeSlice';
import paymentConditionReducer from './slices/paymentConditions/paymentConditionSlice';
import paymentMethodReducer from './slices/paymentMethods/paymentMethodSlice';
import locationReducer from './slices/locations/locationSlice';
import notificationReducer from './slices/notification/notificationSlice'
import notificationModalReducer from './slices/notification/notificationModalSlice'
import twoFactorAuthReducer from './slices/twoFactorAuth/twoFactorAuthSlice'
import recoveryCodeReducer from "./slices/recoveryCode/RecoveryCodeSlice";
import loadingReducer from './slices/loading/loadingSlice'
import userReducer from './slices/users/usersSlice';
import userProfileReducer from './slices/userProfile/userProfileSlice'
import roleReducer from './slices/role/roleSlice';
import rolePermissionsReducer from './slices/rolePermissions/rolePermissionsSlice';
import userPermissionOverridesReducer from './slices/userPermissionOverrides/userPermissionOverridesSlice';
import branchReducer from './slices/branches/branchSlice';
import branchConfigurationReducer from './slices/branches/branchConfigurationSlice';

import productReducer from './slices/product/productSlice';
import productSizesReducer from './slices/product/productSizeSlice';
import productColorsReducer from './slices/product/productColorSlice';
import productUnitReducer from './slices/productUnit/productUnitSlice';
import productCategoryReducer from './slices/productCategory/productCategorySlice';
import brandReducer from './slices/product/brandSlice';
import productCodeReducer from './slices/product/productCodeSlice';
import productSubCategoryReducer from './slices/product/productSubCategorySlice';

import itemTypeReducer from './slices/item/itemTypeSlice';
import economicActivityReducer from './slices/economicActivity/economicActivitySlice';
import discountReducer from './slices/discount/discountSlice';
import suppliersReducer from './slices/supplier/supplierSlice';
import customerReducer from './slices/customer/customerSlice';

import basePurchaseReducer from './slices/purchases/basePurchaseSlice';
import importPurchaseReducer from './slices/purchases/importPurchaseSlice';
import taxCreditPurchaseReducer from './slices/purchases/taxCreditPurchaseSlice';
import creditNoteReducer from './slices/purchases/creditNoteSlice';
import creditNoteLookupReducer from './slices/purchases/creditNoteLookupSlice';
import excludedSubjectReducer from './slices/purchases/excludedSubjectSlice';
import debitNoteReducer from './slices/purchases/debitNoteSlice';
import debitNoteLookupReducer from './slices/purchases/debitNoteLookupSlice';
import productSettlementReducer from './slices/settlements/productSettlementSlice';
import purchaseInvalidationReducer from './slices/purchases/purchaseInvalidationSlice';

import documentSequenceReducer from './slices/document/documentSequenceSlice';
import reportTypeReducer from './slices/report/reportTypeSlice';
import reportExportReducer from './slices/report/reportExportSlice';

import inventoryStockReducer from './slices/inventory/inventoryStockSlice';
import initialStockReducer from './slices/inventory/initialStockSlice';
import inventoryTransferQueryReducer from './slices/inventory/inventoryTransferQuerySlice';
import inventoryTransferReducer from './slices/inventory/inventoryTransferSlice';
import inventoryAdjustmentReducer from './slices/inventory/adjustment/inventoryAdjustmentSlice';
import inventoryAdjustmentQueryReducer from './slices/inventory/inventoryAdjustmentQuerySlice';
import inventoryMovementReducer from './slices/inventory/inventoryMovementSlice';
import productStockLookupReducer from './slices/inventory/productStockLookupSlice';


// employee
import employeeReducer from './slices/employees/employeeSlice';

import importTypeReducer from './slices/importType/importTypeSlice';
import pdfTypeReducer from './slices/pdf/pdfTypeSlice';
import importExcelReducer from './slices/excel/importExcelSlice';
import businessConfigReducer from './slices/business/businessConfigSlice';
import electronicDocumentTemplateReducer from './slices/documentTemplate/electronicDocumentTemplateSlice';
import printerReducer from './slices/hardware/printerSlice';
import cashDrawerReducer from './slices/hardware/cashDrawerSlice';
import productPanelReducer from './slices/productPanel/productPanelSlice';
import saleReducer from './slices/sale/saleSlice';
import saleInvalidationReducer from './slices/sale/saleInvalidationSlice';
import multiplePaymentReducer from './slices/sale/multiplePaymentSlice';
import creditFiscalSaleReducer from './slices/sale/creditFiscalSaleSlice';
import creditNoteSaleLookupReducer from './slices/sale/creditNoteSaleLookupSlice';
import consumerFinalSaleReducer from './slices/sale/consumerFinalSaleSlice';
import creditNoteSaleReducer from './slices/sale/creditNoteSaleSlice';
import creditNoteBalanceReducer from './slices/sale/creditNoteBalanceSlice';
import exportInvoiceSaleReducer from './slices/sale/exportInvoiceSaleSlice';
import quotationReducer from './slices/sale/quotationSlice';
import quotationHistoryReducer from './slices/sale/quotationHistorySlice';

import termReducer from './slices/term/termSlice';
import invalidationTypeReducer from './slices/invalidationTypes/invalidationTypeSlice';

// System
import systemPlansReducer from './slices/system/systemPlanSlice';


// dashboard
import customerDashboardReducer from './slices/dashboard/customerDashboardSlice';
import saleDashboardReducer from './slices/dashboard/saleDashboardSlice';
import inventoryDashboardReducer from './slices/dashboard/inventoryDashboardSlice';
import purchaseDashboardReducer from './slices/dashboard/purchaseDashboardSlice';
import supplierDashboardReducer from './slices/dashboard/supplierDashboardSlice';

// Hacienda
import taxpayerAuthenticationConfigReducer from './slices/hacienda/taxpayerAuthenticationConfigSlice';
import taxpayerCertificateReducer from './slices/hacienda/taxpayerCertificateSlice';
import dteInvalidationLogReducer from './slices/hacienda/dteInvalidationLogSlice';

// Dte
import dteConfigurationReducer from './slices/hacienda/dteConfigurationSlice';
import contingencyEventReducer from './slices/dte/contingencyEventSlice';
import dteSystemReducer from './slices/dte/dteSystemSlice';
import dteTestRequirementReducer from "./slices/dte/dteTestRequirementSlice";
import enabledDocumentTypesReducer from './slices/dte/enabledDocumentTypesSlice';
import testProgressReducer from './slices/dte/testProgressSlice';
import testProgressAdminReducer from './slices/dte/testProgressAdminSlice';

import emailConfigReducer from './slices/email/emailConfigSlice';


// Settings
import allowedOptionsReducer from './slices/settings/allowedOptionsSlice';
import systemOperationModeReducer from './slices/settings/systemOperationModeSlice';
import backupReducer from './slices/settings/backupSlice';

// Perfil de Cliente
import clientProfileDropdownReducer from './slices/clientProfiles/clientProfileDropdownSlice';


// Sidebar
import sidebarReducer from './slices/sidebar/sidebarSlice';

// Access
import routeAccessReducer from './slices/access/routeAccessSlice';

// UI
import topProgressReducer from "./slices/ui/topProgressSlice";
import uiVisibilityReducer from "./slices/ui/uiVisibilitySlice";

import printingReducer from './slices/printing/printingSlice';

// Qztray
import qzTrayCertificateReducer from './slices/qztray/qzTrayCertificateSlice';
import qzTraySignerReducer from './slices/qztray/qzTraySignerSlice';
import qzTrayConfigurationReducer from './slices/qztray/qzTrayConfigurationSlice';
import qzTrayConnectionReducer from './slices/qztray/qzTrayConnectionSlice';
import qzTrayClientReducer from './slices/qztray/qzTrayClientSlice';
import qzTrayPreviewReducer from './slices/qztray/qzTrayPreviewSlice';
import qzTrayPrintReducer from './slices/qztray/qzTrayPrintSlice';
import qzTrayPublicCertificateReducer from "./slices/qztray/qzTrayPublicCertificateSlice";

// Modals
import leaveConfirmReducer from './slices/modals/leaveConfirmSlice';

// settings
import correlativesAdminReducer from './slices/settings/correlativesAdminSlice';

// transport
import transportModeReducer from './slices/transportModes/transportModeSlice';

// countries
import countryReducer from './slices/countries/countrySlice';

// exportRegimen
import exportRegimeReducer from './slices/exportRegimes/exportRegimeSlice';

import fiscalPrecinctReducer from './slices/fiscalPrecincts/fiscalPrecinctSlice';

// incoterm
import incotermReducer from './slices/incoterm/incotermSlice';

// Cash
import cashRegisterReducer from './slices/cashRegister/cashRegisterSlice';
import cashSessionReducer from "./slices/cash/cashSessionSlice";
import cashWithdrawalReducer from './slices/cash/cashWithdrawalSlice';
import cashMovementReducer from './slices/cash/cashMovementSlice';
import cashIncomeReducer from './slices/cash/cashIncomeSlice';
import cashAdjustmentReducer from './slices/cash/cashAdjustmentSlice';
import cashCountReducer from './slices/cash/cashCountSlice';
import cashSummaryReducer from './slices/cash/cashSummarySlice';
import cashReportReducer from './slices/cash/cashReportSlice';
import cashClosureReducer from './slices/cash/cashClosureSlice';

import receivableTableReducer from '../modules/receivable/table/store/receivableTable.slice';
import receivablePaymentReducer from '../modules/receivable/payments/store/receivablePayment.slice';
import receivableDetailReducer from '../modules/receivable/detail/store/receivableDetail.slice';
import paymentHistoryCxcReducer from '../modules/receivable/history/store/paymentHistoryCxc.slice';
import agingReportReducer from '../modules/receivable/aging/store/agingReport.slice';
import payableTableReducer from '../modules/payable/table/store/PayableTable.slice';
import payablePaymentReducer from '../modules/payable/payments/store/PayablePayment.slice';
import payableDetailReducer from '../modules/payable/detail/store/PayableDetail.slice';
import paymentHistoryCxpReducer from '../modules/payable/history/store/paymentHistoryCxp.slice';
import payableAgingReportReducer from '../modules/payable/aging/store/agingReport.slice';
import restaurantPrinterReducer from './slices/restaurant/restaurantPrinterSlice';
import restaurantPreparationStationReducer from './slices/restaurant/restaurantPreparationStationSlice';
import restaurantDiningRoomReducer from './slices/restaurant/restaurantDiningRoomSlice';
import restaurantTableReducer from './slices/restaurant/restaurantTableSlice';
import restaurantMenuReducer from './slices/restaurant/restaurantMenuSlice';
import restaurantRawMaterialCategoryReducer from './slices/restaurant/restaurantRawMaterialCategorySlice';
import restaurantRawMaterialReducer from './slices/restaurant/restaurantRawMaterialSlice';
import restaurantInventoryReducer from './slices/restaurant/restaurantInventorySlice';
import restaurantUnitConversionReducer from './slices/restaurant/restaurantUnitConversionSlice';
import restaurantRecipeReducer from './slices/restaurant/restaurantRecipeSlice';
import restaurantPurchaseOrderReducer from './slices/restaurant/restaurantPurchaseOrderSlice';
import restaurantProductionPlannerReducer from './slices/restaurant/restaurantProductionPlannerSlice';
import restaurantKitchenOrderReducer from './slices/restaurant/restaurantKitchenOrderSlice';

// websocket
import saleDteRealtimeReducer from '../store/slices/sale-dte/saleDteRealtimeSlice';
import purchaseDteRealtimeReducer from '../store/slices/purchase-dte/purchaseDteRealtimeSlice';
import realtimeReducer from './slices/realtime/realtimeSlice';

// backgroundjobs
import backgroundJobReducer from './slices/backgroundjobs/backgroundJobSlice'; 

// Fiscal
import returnEventReducer from './slices/fiscal/returnEventSlice';
import purchaseReturnEventReducer from './slices/fiscal/purchaseReturnEventSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        authUsers: authUsersReducer,

        routes: routesReducer,

        printing: printingReducer,

        profileReport: profileReportReducer,

        routeAccess: routeAccessReducer,
        sidebar: sidebarReducer,

        module: moduleReducer,
        moduleCategory: moduleCategoryReducer,
        alerts: alertsSlice,
        formAlert: formAlertSliceReducer,
        modals: modalsReducer,
        leaveConfirm: leaveConfirmReducer,
        confirmModal: confirmModalReducer,
        session: sessionReducer,
        menu: menuReducer,
        categoriesMenu: categoriesMenuReducer,
        entityType: entityTypeReducer,
        taxpayerCategory: taxpayerCategoryReducer,
        documentType: documentTypeReducer,
        documentIdentificationType: documentIdentificationTypeReducer,
        paymentCondition: paymentConditionReducer,
        paymentMethod: paymentMethodReducer,
        location: locationReducer,

        notifications: notificationReducer,
        notificationModal: notificationModalReducer,
        twoFactorAuth: twoFactorAuthReducer,
        recoveryCodes: recoveryCodeReducer,
        loading: loadingReducer,
        users: userReducer,
        userProfile: userProfileReducer,
        roles: roleReducer,
        rolePermissions: rolePermissionsReducer,
        userPermissionOverrides: userPermissionOverridesReducer,

        branch: branchReducer,
        branchConfiguration: branchConfigurationReducer,

        products: productReducer,
        productSizes: productSizesReducer,
        productColors: productColorsReducer,
        productUnit: productUnitReducer,
        productCategory: productCategoryReducer,
        brand: brandReducer,
        productSubCategory: productSubCategoryReducer,
        productCode: productCodeReducer,
        itemType: itemTypeReducer,

        economicActivity: economicActivityReducer,
        discounts: discountReducer,
        suppliers: suppliersReducer,
        customers: customerReducer,

        // Compras
        basePurchase: basePurchaseReducer,
        importPurchase: importPurchaseReducer,
        taxCreditPurchase: taxCreditPurchaseReducer,
        creditNote: creditNoteReducer,
        creditNoteLookup: creditNoteLookupReducer,
        excludedSubject: excludedSubjectReducer,
        debitNote: debitNoteReducer,
        debitNoteLookup: debitNoteLookupReducer,
        productSettlement: productSettlementReducer,
        purchaseInvalidation: purchaseInvalidationReducer,

        documentSequence: documentSequenceReducer,

        reportType: reportTypeReducer,
        importType: importTypeReducer,
        reportExport: reportExportReducer,
        importExcel: importExcelReducer,
        pdfType: pdfTypeReducer,

        // Inventario
        inventoryStock: inventoryStockReducer,
        initialStock: initialStockReducer,
        inventoryTransferQuery: inventoryTransferQueryReducer,
        inventoryTransfer: inventoryTransferReducer,
        inventoryAdjustment: inventoryAdjustmentReducer,
        inventoryAdjustmentQuery: inventoryAdjustmentQueryReducer,
        inventoryMovement: inventoryMovementReducer,
        productStockLookup: productStockLookupReducer,

        businessConfig: businessConfigReducer,
        electronicDocumentTemplate: electronicDocumentTemplateReducer,
        printer: printerReducer,
        cashDrawer: cashDrawerReducer,

        // Ventas
        sale: saleReducer,
        saleInvalidation: saleInvalidationReducer,
        productPanel: productPanelReducer,
        multiplePayment: multiplePaymentReducer,
        creditFiscalSale: creditFiscalSaleReducer,
        creditNoteSaleLookup: creditNoteSaleLookupReducer,
        consumerFinalSale: consumerFinalSaleReducer,
        creditNoteSale: creditNoteSaleReducer,
        creditNoteBalance: creditNoteBalanceReducer,
        exportInvoiceSale: exportInvoiceSaleReducer,
        quotation: quotationReducer,
        quotationHistory: quotationHistoryReducer,

        term: termReducer,
        invalidationType: invalidationTypeReducer,

        customerDashboard: customerDashboardReducer,
        saleDashboard: saleDashboardReducer,
        inventoryDashboard: inventoryDashboardReducer,
        purchaseDashboard: purchaseDashboardReducer,
        supplierDashboard: supplierDashboardReducer,

        // dte
        dteConfiguration: dteConfigurationReducer,
        contingencyEvent: contingencyEventReducer,
        dteSystem: dteSystemReducer,
        dteTestRequirements: dteTestRequirementReducer,
        enabledDocumentTypes: enabledDocumentTypesReducer,
        testProgress: testProgressReducer,
        testProgressAdmin: testProgressAdminReducer,

        // Hacienda
        taxpayerAuthenticationConfig: taxpayerAuthenticationConfigReducer,
        taxpayerCertificate: taxpayerCertificateReducer,
        dteInvalidationLog: dteInvalidationLogReducer,

        // Servicios Externos
        emailConfig: emailConfigReducer,


        // Settings
        allowedOptions: allowedOptionsReducer,
        systemOperationMode: systemOperationModeReducer,
        backup: backupReducer,

        // Perfil de Cliente
        clientProfileDropdown: clientProfileDropdownReducer,

        // Qztrat
        qzTrayCertificate: qzTrayCertificateReducer,
        qzTraySigner: qzTraySignerReducer,
        qzTrayConfiguration: qzTrayConfigurationReducer,
        qzTrayConnection: qzTrayConnectionReducer,
        qzTrayClient: qzTrayClientReducer,
        qzTrayPreview: qzTrayPreviewReducer,
        qzTrayPrint: qzTrayPrintReducer,
        qzTrayPublicCertificate: qzTrayPublicCertificateReducer,

        // UI
        topProgress: topProgressReducer,
        uiVisibility: uiVisibilityReducer,

        // settings
        correlativesAdmin: correlativesAdminReducer,

        // transport
        transportMode: transportModeReducer,

        // countries
        country: countryReducer,

        // exportRegimen
        exportRegime: exportRegimeReducer,

        // fiscalPrecinct
        fiscalPrecinct: fiscalPrecinctReducer,

        // incoterm
        incoterm: incotermReducer,

        // System
        systemPlans: systemPlansReducer,

        // employee
        employee: employeeReducer,

        // Cash
        cashRegister: cashRegisterReducer,
        cashSession: cashSessionReducer,
        cashWithdrawal: cashWithdrawalReducer,
        cashMovement: cashMovementReducer,
        cashIncome: cashIncomeReducer,
        cashAdjustment: cashAdjustmentReducer,
        cashCount: cashCountReducer,
        cashSummary: cashSummaryReducer,
        cashReport: cashReportReducer,
        cashClosure: cashClosureReducer,


        receivableTable: receivableTableReducer,
        receivablePayment: receivablePaymentReducer,
        receivableDetail: receivableDetailReducer,
        paymentHistoryCxc: paymentHistoryCxcReducer,
        agingReport: agingReportReducer,
        payableTable: payableTableReducer,
        payablePayment: payablePaymentReducer,
        payableDetail: payableDetailReducer,
        paymentHistoryCxp: paymentHistoryCxpReducer,
        payableAgingReport: payableAgingReportReducer,


        // Restaurante
        restaurantPrinter: restaurantPrinterReducer,
        restaurantPreparationStation: restaurantPreparationStationReducer,
        restaurantDiningRoom: restaurantDiningRoomReducer,
        restaurantTable: restaurantTableReducer,
        restaurantMenu: restaurantMenuReducer,
        restaurantRawMaterialCategory: restaurantRawMaterialCategoryReducer,
        restaurantRawMaterial: restaurantRawMaterialReducer,
        restaurantInventory: restaurantInventoryReducer,
        restaurantUnitConversion: restaurantUnitConversionReducer,
        restaurantRecipe: restaurantRecipeReducer,
        restaurantPurchaseOrder: restaurantPurchaseOrderReducer,
        restaurantProductionPlanner: restaurantProductionPlannerReducer,
        restaurantKitchenOrder: restaurantKitchenOrderReducer,

        // websocket
        saleDteRealtime: saleDteRealtimeReducer,
        purchaseDteRealtime: purchaseDteRealtimeReducer,
        realtime: realtimeReducer,

        // backgroundjobs
        backgroundJob: backgroundJobReducer,

        // Fiscal
        returnEvent: returnEventReducer,
        purchaseReturnEvent: purchaseReturnEventReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
